export default {
    de: [
        require('./de/airbrake-snow-install-german.mp4'),
        require('./de/airbrake-snow-remove-german.mp4'),
        require('./de/airbrake-MX-install-german.mp4'),
        require('./de/airbrake-MX-remove-german.mp4'),
        require('./de/jawbreaker-install-german.mp4'),
        require('./de/jawbreaker-removal-german.mp4'),
    ],
    en: [
        require('./en/airbrake-snow-install-english.mp4'),
        require('./en/airbrake-snow-remove-english.mp4'),
        require('./en/airbrake-MX-install-english.mp4'),
        require('./en/airbrake-MX-remove-english.mp4'),
        require('./en/jawbreaker-install-english.mp4'),
        require('./en/jawbreaker-removal-english.mp4'),
    ],
    es: [
        require('./es/airbrake-snow-install-spanish.mp4'),
        require('./es/airbrake-snow-remove-spanish.mp4'),
        require('./es/airbrake-MX-install-spanish.mp4'),
        require('./es/airbrake-MX-remove-spanish.mp4'),
        require('./es/jawbreaker-install-spanish.mp4'),
        require('./es/jawbreaker-removal-spanish.mp4'),
    ],
    fr: [
        require('./fr/airbrake-snow-install-french.mp4'),
        require('./fr/airbrake-snow-remove-french.mp4'),
        require('./fr/airbrake-MX-install-french.mp4'),
        require('./fr/airbrake-MX-remove-french.mp4'),
        require('./fr/jawbreaker-install-french.mp4'),
        require('./fr/jawbreaker-removal-french.mp4'),
    ],
    it: [
        require('./it/airbrake-snow-install.mp4'),
        require('./it/airbrake-snow-remove.mp4'),
        require('./it/airbrake-mx-install.mp4'),
        require('./it/airbrake-mx-remove.mp4'),
        require('./it/jawbreaker-install.mp4'),
        require('./it/jawbreaker-remove.mp4'),
    ],
    jp: [
        require('./jp/snow-install-japanese.mp4'),
        require('./jp/snow-remove-japanese.mp4'),
        require('./jp/airbrake-MX-install-japanese.mp4'),
        require('./jp/airbrake-MX-remove-japanese.mp4'),
        require('./jp/jawbreaker-install-japanese.mp4'),
        require('./jp/jawbreaker-removal-japanese.mp4'),
    ],
    kr: [
        require('./kr/airbrake-snow-install-korean.mp4'),
        require('./kr/airbrake-snow-remove-korean.mp4'),
        require('./kr/airbrake-MX-install-korean.mp4'),
        require('./kr/airbrake-MX-remove-korean.mp4'),
        require('./kr/jawbreaker-install-korean.mp4'),
        require('./kr/jawbreaker-removal-korean.mp4'),
    ],
    pr: [
        require('./pr/airbrake-snow-install-portuguese.mp4'),
        require('./pr/airbrake-snow-remove-portuguese.mp4'),
        require('./pr/airbrake-MX-install-portuguese.mp4'),
        require('./pr/airbrake-MX-remove-portuguese.mp4'),
        require('./pr/jawbreaker-install-portuguese.mp4'),
        require('./pr/jawbreaker-removal-portuguese.mp4'),
    ],
    sc: [
        require('./sc/airbrake-snow-install-simpChinese.mp4'),
        require('./sc/airbrake-snow-remove-simpChinese.mp4'),
        require('./sc/Airbrake_MX_Install-simpChinese.mp4'),
        require('./sc/Airbrake_MX_Remove-simpChinese.mp4'),
        require('./sc/jawbreaker-install-simpChinese.mp4'),
        require('./sc/jawbreaker-removal-simpChinese.mp4'),
    ],
    tc: [
        require('./tc/airbrake-snow-install-tradChinese.mp4'),
        require('./tc/airbrake-snow-remove-tradChinese.mp4'),
        require('./tc/airbrake-MX-install-tradChinese.mp4'),
        require('./tc/airbrake-MX-remove-tradChinese.mp4'),
        require('./tc/jawbreaker-install-tradChinese.mp4'),
        require('./tc/jawbreaker-removal-tradChinese.mp4'),
    ],
};



// WEBPACK FOOTER //
// ./src/screens/switchlock/video/index.js